import React, { useCallback } from 'react';
import { DateUtils } from '@vectord/utils';
import { Icon, Tooltip } from '@vectord/components';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import has from 'lodash/has';

import {
  SbatGroupInstructors,
  SbatGroupSuperBatches,
  selectedBulkUpdateSbatGroupsSelector,
  setSelectedRescheduleSbatGroup,
  setSelectedSbatGroups,
} from 'features/classCreation';
import DeleteSbatGroup from '../DeleteSbatGroup';
import styles from './ScheduledClassesRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

export default function ScheduledClassesRow({
  sbatGroup,
  isDeleteDisabled = false,
  isEditDisabled = false,
  isSelectable = false,
}) {
  const dispatch = useDispatch();
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);

  const handleClick = useCallback(() => {
    if (isSelectable) {
      dispatch(setSelectedSbatGroups(sbatGroup));
    }
  }, [dispatch, sbatGroup, isSelectable]);

  const handleEdit = useCallback(
    (event) => {
      event.stopPropagation();
      if (!isEditDisabled) {
        dispatch(setSelectedRescheduleSbatGroup(sbatGroup));
      }
    },
    [dispatch, sbatGroup, isEditDisabled]
  );

  return (
    <TableRow
      onClick={handleClick}
      className={classNames({
        border: isSelectable,
        cursor: isSelectable,
        [styles.selected]: has(selectedSbatGroups, sbatGroup.id),
      })}
    >
      <TableCell>{DateUtils.toDateDayTime(sbatGroup.date_of_topic)}</TableCell>
      <TableCell>{sbatGroup.academy_topic.title}</TableCell>
      <TableCell>
        <SbatGroupSuperBatches
          trimIfMany
          sbatGroup={sbatGroup}
        />
      </TableCell>
      <TableCell>{sbatGroup.academy_topic.academy_module.name}</TableCell>
      <TableCell>{sbatGroup.academy_topic.junction_number || '-'}</TableCell>
      <TableCell>
        <SbatGroupInstructors sbatGroup={sbatGroup} />
      </TableCell>
      <TableCell>
        <Tooltip
          isDisabled={!isEditDisabled}
          title="You cannot edit classes after they are completed!"
        >
          <Link
            className={classNames('link', {
              [styles.disabled]: isEditDisabled,
            })}
            to={`/classes/edit-sbat-group/${sbatGroup.id}`}
            onClick={handleEdit}
          >
            <Icon
              name="pencil"
              className={classNames('primary m-l-xxs', {
                cursor: !isEditDisabled,
                [styles.disabled]: isEditDisabled,
              })}
            />
          </Link>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip
          isDisabled={!isDeleteDisabled}
          title="You cannot delete classes after they are completed!"
        >
          <DeleteSbatGroup
            isDisabled={isDeleteDisabled}
            sbatGroup={sbatGroup}
            className={classNames({
              cursor: !isDeleteDisabled,
              [styles.disabled]: isDeleteDisabled,
            })}
          />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}
